module.exports = __webpack_public_path__ + "static/img/3.021f52d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/cpxh/3.jpg
// module id = IXrm
// module chunks = 0